//firebase.js

import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

var firebaseConfig = {
    apiKey: "AIzaSyCw8CVbEoGBY3HW1ZabJG4klkLwLKYiFlE",
    authDomain: "ithoobadmin.firebaseapp.com",
    projectId: "ithoobadmin",
    storageBucket: "ithoobadmin.appspot.com",
    messagingSenderId: "125201676355",
    appId: "1:125201676355:web:9d7a3589700ff4c4683cf6",
    measurementId: "G-K77688QBGC"
}

firebase.initializeApp(firebaseConfig)

export default firebase.messaging()